import ThirdPartyActorsService from "@/api/services/thirdPartyActors";
import { toCamelCase } from "@estaly/ui";

export default {
  namespaced: true,
  state: {
    actors: [],
  },
  getters: {
    getActors(state) {
      return state.actors;
    },
  },
  mutations: {
    setActors(state, actors) {
      state.actors = actors;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      const response = await ThirdPartyActorsService.fetchAll();
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setActors", data.records);
      return { ...response, data };
    },
  },
};
